import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedInCallback } from '../../../../service/cognito.service';
import { UserLoginService } from '../../../../service/user-login.service';

enum LpHomeState {
  Authentication,
  ValidatingRole,
  Error,
}

@Component({
  selector: 'app-loss-prevention-home',
  templateUrl: './loss-prevention-home.component.html',
  styleUrl: './loss-prevention-home.component.scss',
  standalone: false,
})
export class LossPreventionHomeComponent implements OnInit, LoggedInCallback {
  private router = inject(Router);
  private userService = inject(UserLoginService);

  LpHomeState = LpHomeState;
  state = signal<LpHomeState>(LpHomeState.Authentication);
  errorMessage = signal<string | null>(null);

  constructor() {
    this.userService.isAuthenticated(this);
  }

  ngOnInit() {
    this.state.set(LpHomeState.Authentication);
    this.userService.currentProfileLoaded$.subscribe(
      (me) => {
        if (me.user_id === 'anonymous') {
          this.router.navigate(['/home/login']);
          return;
        }
        const roles = this.userService.currentProfileRoleList();
        this.state.set(LpHomeState.ValidatingRole);

        const isAdmin = roles.includes('admin');
        const isValidator = roles.includes('validator');
        const isInvestigator = roles.includes('investigator');
        const isSelfServiceInvestigator = roles.includes('self-service-investigator');

        if (isAdmin || isValidator) {
          this.router.navigate(['/lp/admin']);
          return;
        }

        if (isSelfServiceInvestigator) {
          this.router.navigate(['/lp/self-service']);
          return;
        }

        if (isInvestigator) {
          this.router.navigate(['/lp/review']);
          return;
        }

        this.state.set(LpHomeState.Error);
        this.errorMessage.set('User does not have a role that allows access to the Loss Prevention Portal');
      },
      (err) => {
        this.state.set(LpHomeState.Error);
        this.errorMessage.set(JSON.stringify(err));
      },
    );
  }

  isLoggedIn(_: string, loggedIn: boolean): void {
    if (!loggedIn) {
      this.router.navigate(['/home/login']);
    }
  }
}
